export const DESKTOP_BAR_HEIGHT = 12;
